import React,{useState,useEffect} from "react";
import "./style/debtPayOff.css";
import { CategoryChart } from "./components/CategoryChart";
import { DebtList } from "./components/DebtList";
import { TransactionList } from "./components/TransactionList";
import { PayOffDetails } from "./components/PayOffDetails";
import { PayOffProgress } from "./components/PayOffProgress";
import { Amortization } from "./components/Amortization";
import { PayOffTimeline } from "./components/PayOffTimeline";
import { PayOffListing } from "./components/PayOffListing";
import { useHistory, useLocation } from "react-router-dom";
import FETCH from "../../../utils/fetch";
import { MODULE_API } from "../../../apis";
import moment from "moment";
export const DebtPayOffDashboard = () => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);

  const [liabilitiesCredit, setLiabilitesCredit] = useState([]);
  const [transactionList, setTransactionList] = useState([]);
  const [selectedPriority,setSelectedPriority] =useState(null);
  const [extraPaid,setExtraPaid] =useState(null);
  const [amortizationData, setAmortizationData] = useState(null);
  const [amortizationDataEach, setAmortizationDataEach] = useState(null);
  const [totalSumValues, setTotalSumValues] = useState(null);

  const getLiabilitesList = async () => {
    try {
        setLoading(true);
        let datares = await FETCH.post({
          url: "client-module-service/client-module/list",
          id: `?module=Liabilities and Credit&page=1&limit=30`,
          body: {},
        });
        setLoading(false);
        if (datares && datares.records) {
          datares.records.map((item) => {
            if (item.subType == "Credit") {
              item["Nickname of Liabilities"] = item["Nickname of Credit"];
              item["Initial Loan Amount"] = item["Credit Balance"];
              item["Interest Rate"] = item["Interest Rate (or APR%)"];
              item["Maturity Date"] = item["Point Expiration"];
              item["Monthly Payment"] =
                item["Monthly Payment"] && item["Monthly Payment"].toString();
              item["Start Date"] = new Date();
            }
          });

          setLiabilitesCredit(datares.records);
        }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getTransactionList = async () => {
    try {
        setLoading(true);
        let datares = await FETCH.get({
          url: "client-module-service/lability-transaction",
        });
        setLoading(false);
        if (datares && datares.data && datares.data.rows) {
          setTransactionList(datares.data.rows);
        }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getDebtPayOff = async () => {
    try {
        setLoading(true);
        let datares = await MODULE_API.getPayOffData();

        if (datares && datares.data && datares.data.rows) {
          // setPayOffData(datares.data.rows);
          if(datares.data.rows[0]){
            // setSnowball(datares.data.rows[0].snowball);
            setSelectedPriority(datares.data.rows[0].strategy);
            setExtraPaid(datares.data.rows[0].snowball)
            // setTotalPaid(
            //   datares.data.rows[0].snowball + totalMinimumMonthlyPayment
            // );
          }
        }
        setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const valueTotal = liabilitiesCredit.reduce(
    (sum, item) => {
      const monthlyPayment = parseFloat(item['Monthly Payment']);
      return isNaN(monthlyPayment) ? sum : sum + monthlyPayment;
    },
    0
  );
  
  console.log("valueTotal",valueTotal)

  useEffect(() => {
    if (liabilitiesCredit && liabilitiesCredit.length > 0) {
      const amortizationData = [];
      let totalPrincipalPaidSum = 0;
      let totalRemainingBalance = 0;
      let totalPaid = 0;
  
      liabilitiesCredit.forEach(item => {
        const maturityDate = moment(item["Maturity Date"]);
        const todayDate = moment();
        const diffDuration = moment.duration(maturityDate.diff(todayDate));
        const years = diffDuration.years();
        const months = diffDuration.months();
        const days = diffDuration.days();
        const durationString = `in ${years} years ${months} months ${days} days`;
  
        let interestRate = +item["Interest Rate"];
        let ILA = +item["Initial Loan Amount"];
        let monthlyPayment = parseFloat(+item["Monthly Payment"]);
        let startDate = item["Start Date"] || new Date();
        let monthlyInterestRate = Math.pow(1 + interestRate / 100, 1 / 12) - 1;
        let monthlyInterestRate1 = ((interestRate / 100)/ 12);

        let amortizationArray = [];
        let principalPaidSum = 0;
        let remainingBalance = ILA;
        let currentDate = new Date(startDate);
        const relevantTransactions = transactionList && transactionList.filter(transaction => transaction.itemId === item.id);
        let count = 0;
        while (remainingBalance > 0) {
          count++;
          let interestPayment = remainingBalance * monthlyInterestRate1;
          let principalPaid = monthlyPayment - interestPayment;
          remainingBalance -= principalPaid;
          if(principalPaid<0){
            break;
          }
          console.log("principalPaid222",principalPaid)
          if (relevantTransactions && relevantTransactions.length > 0) {
            if (count <= relevantTransactions.length) {
              principalPaidSum += principalPaid;
              totalPaid += +monthlyPayment;
            }
          }
  
          let amortizationEntry = {
            month: currentDate,
            principalPaid: principalPaid.toFixed(2),
            interestPayment: interestPayment.toFixed(2),
            remainingBalance: remainingBalance.toFixed(2),
          };
          amortizationArray.push(amortizationEntry);
  
          currentDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth() + 1,
            currentDate.getDate()
          );
        }
  
        amortizationData.push({
          item,
          durationString,
          amortizationArray,
          principalPaidSum: principalPaidSum && principalPaidSum.toFixed(2),
          remainingBalance: remainingBalance && remainingBalance.toFixed(2),
          totalPaid: (principalPaidSum + (amortizationArray.length * monthlyPayment)).toFixed(2),
        });
  
        totalPrincipalPaidSum += parseFloat(principalPaidSum);
        totalRemainingBalance += parseFloat(remainingBalance);
        totalPaid += parseFloat(principalPaidSum) + (amortizationArray.length * monthlyPayment);
      });
  
      let summedAmortizationData = [];
      amortizationData.forEach(item => {
        item.amortizationArray.forEach((entry, index) => {
          // If the summedAmortizationData array doesn't have an entry for the current index yet, create one
          if (!summedAmortizationData[index]) {
            summedAmortizationData[index] = { ...entry };
          } else {
            // Otherwise, sum the values for each property
            summedAmortizationData[index].principalPaid = (parseFloat(summedAmortizationData[index].principalPaid) + parseFloat(entry.principalPaid)).toFixed(2);
            summedAmortizationData[index].interestPayment = (parseFloat(summedAmortizationData[index].interestPayment) + parseFloat(entry.interestPayment)).toFixed(2);
            summedAmortizationData[index].remainingBalance = (parseFloat(summedAmortizationData[index].remainingBalance) + parseFloat(entry.remainingBalance)).toFixed(2);
          }
        });
      });
      let summedValues = {
        totalPrincipalPaidSum: 0,
        totalRemainingBalance: 0,
        sumTotalPaid: 0,
        totalMonthlyPayment:0,
      };
      amortizationData.forEach(item => {
        // Sum the values for each property
        summedValues.totalPrincipalPaidSum += parseFloat(item.principalPaidSum || 0);
        summedValues.totalRemainingBalance += parseFloat(item.remainingBalance || 0);
        summedValues.sumTotalPaid += parseFloat(item.totalPaid || 0);
        summedValues.totalMonthlyPayment += item.item["Monthly Payment"] ? parseFloat(item.item["Monthly Payment"]) : 0;
      });
      setAmortizationData(summedAmortizationData);
      setAmortizationDataEach(amortizationData);
      setTotalSumValues(summedValues);
      console.log("summedAmortizationData",amortizationData,summedValues);
      // console.log("amortizationData",amortizationData)

      // const summaryAmortizationArray = amortizationData.reduce((acc, curr) => {
      //   return acc.concat(curr.amortizationArray);
      // }, []);

    }
  }, [liabilitiesCredit,transactionList]);

  
  
  useEffect(() => {
    // getLiabilitesList();
    getAll();
  }, []);
  const getAll= async()=>{
    await getDebtPayOff();
    await getLiabilitesList();
    await getTransactionList();
  }

  return (
    <div>
      <div className="MainDebtDashboard">
        <div className="mainContainerDebtLeft">
          <div className="subContainerDebtMain">
            <div className="chartCard">
              <CategoryChart data={liabilitiesCredit && liabilitiesCredit} loading={loading} />{" "}
            </div>
            <div className="DebtCard">
              <DebtList data={liabilitiesCredit && liabilitiesCredit} loading={loading} />
            </div>
          </div>
        </div>

        <div
          className="mainContainerDebtRight"
          style={{ flexGrow: "inherit", display: "flex" }}
        >
          <div className="subContainerDebtMain">
            <div className="RightCard">
              <TransactionList data={transactionList && transactionList} modules={liabilitiesCredit && liabilitiesCredit} loading={loading} />
            </div>
          </div>
        </div>
      </div>
      <div
        className="MainDebtDashboard"
        style={{ padding: "0rem 1rem 1rem 1rem" }}
      >
        <div className="mainContainerDebtLeft">
          <div className="subContainerDebtMain">
            <div className="chartCard" style={{cursor:"inherit"}}
            // onClick={() => {
            //   history.push({
            //     pathname: "/strategy",
            //     total: valueTotal && valueTotal,
            //   });
            // }}
            >
              <PayOffDetails data={liabilitiesCredit && liabilitiesCredit} valueTotal={valueTotal && valueTotal} selectedPlan={selectedPriority && selectedPriority} loading={loading} />
            </div>
            <div className="payOffCard">
              <PayOffProgress data={amortizationData && amortizationData} totalPaid={totalSumValues && totalSumValues} loading={loading} />
            </div>
          </div>
        </div>

        <div className="mainContainerDebtRight" style={{display:"flex"}}>
          <div className="subContainerDebtMain">
            <div className="RightCard">
              <Amortization data={amortizationDataEach && amortizationDataEach} paid={transactionList && transactionList} loading={loading} />
            </div>
          </div>
        </div>
      </div>

      <div
        className="MainDebtDashboard"
        style={{ padding: "0rem 1rem 1rem 1rem" }}
      >
        <div className="mainContainerDebtLeft" style={{ width: "59%",flexGrow: "inherit",display: "flex", }}>
          <div className="subContainerDebtMain">
            <div className="MainChartCard">
              <PayOffTimeline data={liabilitiesCredit && liabilitiesCredit} transaction={transactionList && transactionList} extra={extraPaid && extraPaid} strategy={selectedPriority && selectedPriority} loading={loading} />
            </div>
          </div>
        </div>

        <div
          className="mainContainerDebtRight"
          style={{ width: "40%", display: "flex", flexGrow: "inherit" }}
        >
          <div className="subContainerDebtMain">
            <div className="RightCard">
              <PayOffListing data={amortizationData && amortizationData} totalPaid={totalSumValues && totalSumValues} loading={loading} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
